// extracted by mini-css-extract-plugin
module.exports = {"divider":"AgencyPage_divider__fLRym"};